import { lazy } from 'react';

import OktaLoginCallback from './okta/OktaLoginCallback';
import OktaPostLoginCallback from './okta/OktaPostLoginCallback';
import OktaPostLogoutCallback from './okta/OktaPostLogoutCallback';

export const routes = [
    { component: OktaLoginCallback, permissions: [], path: '/sso/okta' },
    { component: OktaPostLoginCallback, permissions: [], path: '/sso/okta/postLogin' },
    { component: OktaPostLogoutCallback, permissions: [], path: '/sso/okta/logout' },
    {
        component: lazy(() => import('module/auth/login/selectUserLevelRole/SelectUserLevelRolePage')),
        permissions: [],
        path: '/selectRole',
    },
    {
        component: lazy(() => import('module/auth/login/selectRoleView/SelectRoleViewPage')),
        permissions: [],
        path: '/selectRoleView',
    },
    {
        component: lazy(() => import('module/auth/forgotUser/forgotUser.page')),
        permissions: [],
        path: '/forgotUser',
    },
    {
        component: lazy(() => import('module/auth/security_question/security_question')),
        permissions: [],
        path: '/securityQuestions',
    },
    {
        component: lazy(() => import('module/auth/security_question/security_answers/security_answers')),
        permissions: [],
        path: '/securityQuestions/securityAnswers',
    },
    {
        component: lazy(() => import('module/auth/login/createpass/create_password')),
        permissions: [],
        path: '/createPassword',
    },
    {
        component: lazy(() => import('module/auth/security_question/security_answers/security_answers')),
        permissions: [],
        path: '/resetPassword',
    },
    {
        component: lazy(() => import('module/auth/dashboard/dashboard.page')),
        permissions: [],
        path: '/dashboard',
    },
];
